import { render, staticRenderFns } from "./profileKycActivityLog.vue?vue&type=template&id=e050f4e4"
import script from "./profileKycActivityLog.vue?vue&type=script&lang=js"
export * from "./profileKycActivityLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports